import { columns } from "@/components/tables/items/columns";
import { DataTable } from "@/components/tables/items/table";
import { httpClient } from "@/lib/http-client";
import { HydrationBoundary, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "@/lib/paraglide-react";
type LoaderData = {
  dehydratedState: DehydratedState;
  id: string;
  offer: SingleOffer | null;
};
import { Route } from "/app/src/routes/{-$locale}/offers/$id/items.tsx";
function ItemsPage() {
  const {
    t
  } = useTranslation();
  const {
    id
  } = Route.useLoaderData() as LoaderData;
  const [page, setPage] = useState({
    pageIndex: 0,
    pageSize: 20
  });
  const [filters, setFilters] = useState<ColumnFiltersState>([]);
  const {
    data: items,
    isLoading,
    isError
  } = useQuery({
    queryKey: ["offer-items", {
      id
    }],
    queryFn: () => httpClient.get<SingleItem[]>(`/offers/${id}/items`)
  });
  if (isLoading) {
    return <div>{t("offerDetail.common.loading")}</div>;
  }
  if (isError) {
    return <section id="offer-items" className="w-full h-full">
        <h2 className="text-2xl font-bold">{t("offerDetail.items.title")}</h2>
        <div>{t("offerDetail.common.somethingWentWrong")}</div>
      </section>;
  }
  return <section id="offer-items" className="h-full w-full">
      <h2 className="text-xl md:text-2xl font-bold mb-4">{t("offerDetail.items.title")}</h2>
      <DataTable<SingleItem, unknown> columns={columns} data={items ?? []} setPage={setPage} page={page} total={items?.length ?? 0} filters={filters} setFilters={setFilters} />
    </section>;
}
const SplitComponent = () => {
  const {
    dehydratedState
  } = Route.useLoaderData() as LoaderData;
  return <HydrationBoundary state={dehydratedState}>
        <ItemsPage />
      </HydrationBoundary>;
};
export { SplitComponent as component };